/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import { PlusCircleFill, Cross } from 'sushiweb/Icons';
import { green, grey, white } from 'sushiweb/tokens/color';
import Select from './Select';

export default function ComboDuoSelectInteger(props) {
  const {
    field,
    saveOptions,
    unSaveOptions,
    inputKey,
    intKey = 'value',
    selectKeyOne = 'selectOne',
    selectKeyTwo = 'selectTwo',
    selectOptions, //selectOptions is same as selectOptionsOne
    selectOptionsTwo,
    isMultiSelect = false,
    defaultValue = [],
    dataToSend = {},
  } = props;
  const [intValue, setIntValue] = useState();
  const integerInputRef = useRef();
  const [selectValue, setSelectValue] = useState();
  const [selectOptionsIdNameMap, setSelectOptionsIdNameMap] = useState();

  useEffect(() => {
    let idNameMap = {};
    for (let i = 0; i < selectOptions.length; i++) {
      idNameMap = {
        ...idNameMap,
        [selectOptions[i].id]: selectOptions[i].name,
      };
    }
    for (let i = 0; i < selectOptionsTwo.length; i++) {
      idNameMap = {
        ...idNameMap,
        [selectOptionsTwo[i].id]: selectOptionsTwo[i].name,
      };
    }
    setSelectOptionsIdNameMap(idNameMap);
  }, [selectOptions]);

  const saveSelectOption = (key, value) => {
    setSelectValue({
      ...selectValue,
      [key]: value,
    });
  };

  const addMoreInput = () => {
    if (!selectValue || !intValue || dataToSend[inputKey]?.length) return;
    saveOptions(inputKey, {
      [selectKeyOne]: selectValue?.selectOne,
      [selectKeyTwo]: selectValue?.selectTwo,
      [intKey]: intValue,
    });
    integerInputRef.current.value = null;
    setIntValue(null);
  };

  const deSelectOption = (option) => {
    unSaveOptions(inputKey, {
      [selectKeyOne]: option[selectKeyOne],
      [selectKeyTwo]: option[selectKeyTwo],
      [intKey]: option[intKey],
    });
    if (!isMultiSelect) {
      integerInputRef.current.value = null;
      setIntValue(null);
    }
  };

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-4'>
      <div className='tw-w-full tw-gap-4'>
        <div className='tw-appearance-none  tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full focus:tw-ring-green-500 focus:tw-border-green-500  tw-border tw-border-solid tw-border-[#cfcfcf] '>
          <div
            className='tw-w-[40%] tw-flex tw-flex-col tw-h-full'
            css={`
              & div {
                border: none !important;
              }
            `}
          >
            <Select
              field={field}
              selectOptions={selectOptions}
              defaultValue={null}
              disabled={false}
              inputKey={selectKeyOne}
              saveOptions={saveSelectOption}
              isMultiSelect={false}
            />
            <span className='tw-border-[1px] tw-border-solid tw-border-[#cfcfcf] tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-w-full'></span>
            <Select
              field={field}
              selectOptions={selectOptionsTwo}
              defaultValue={null}
              disabled={false}
              inputKey={selectKeyTwo}
              saveOptions={saveSelectOption}
              isMultiSelect={false}
            />
          </div>
          <div className=' tw-border-r-[1px] tw-border-solid tw-border-l-0  tw-border-t-0 tw-border-b-0 tw-border-[#cfcfcf] tw-w-0'></div>
          <input
            type='number'
            placeholder={'Please enter value'}
            className={`tw-w-[60%] tw-outline-none tw-border-none tw-rounded-lg tw-px-5 tw-py-2`}
            autoComplete='off'
            onChange={(e) => {
              setIntValue(e.target.value);
            }}
            ref={integerInputRef}
          />
        </div>
        <div
          className={`${
            intValue && selectValue
              ? 'tw-cursor-pointer'
              : 'tw-cursor-not-allowed'
          } `}
          onClick={addMoreInput}
        >
          <PlusCircleFill
            color={`${
              intValue && selectValue?.selectOne && selectValue?.selectTwo
                ? green.z700
                : grey.z500
            }`}
            size={24}
          />
        </div>
      </div>
      {isMultiSelect && dataToSend[inputKey]?.length ? (
        <div className='tw-w-full tw-flex tw-gap-4 '>
          {dataToSend[inputKey].map((prevInput, index) => (
            <span
              className='tw-flex tw-gap-4 tw-py-2 tw-px-3 tw-bg-green-700 tw-text-base-white tw-rounded-full  tw-h-11 tw-min-w-fit'
              key={`${prevInput[selectKeyTwo]}_${prevInput[selectKeyOne]}_${prevInput[intKey]}_${index}}`}
            >
              <span className='tw-text-200 tw-font-medium'>
                {`${selectOptionsIdNameMap[prevInput[selectKeyTwo]]} ${
                  selectOptionsIdNameMap[prevInput[selectKeyOne]]
                } ${prevInput[intKey]}`}
              </span>
              <span className='tw-border tw-border-solid tw-border-[#cfcfcf] tw-rounded-full'>
                <Cross
                  color={white}
                  size={16}
                  onClick={(e) => {
                    e.preventDefault();
                    deSelectOption(prevInput);
                  }}
                />
              </span>
            </span>
          ))}
        </div>
      ) : null}
      {!isMultiSelect && dataToSend[inputKey]?.[intKey] ? (
        <div className='tw-w-full tw-flex tw-gap-4 '>
          <span className='tw-flex tw-gap-4 tw-py-2 tw-px-3 tw-bg-green-700 tw-text-base-white tw-rounded-full  tw-h-11 tw-min-w-fit '>
            <span className='tw-text-200 tw-font-medium'>
              {`${selectOptionsIdNameMap[dataToSend[inputKey][selectKeyTwo]]} ${
                selectOptionsIdNameMap[dataToSend[inputKey][selectKeyOne]]
              } ${dataToSend[inputKey][intKey]}`}
            </span>
            <span className='tw-border tw-border-solid tw-border-[#cfcfcf] tw-rounded-full'>
              <Cross
                color={white}
                size={16}
                onClick={(e) => {
                  e.preventDefault();
                  deSelectOption(dataToSend[inputKey]);
                }}
              />
            </span>
          </span>
        </div>
      ) : null}
    </div>
  );
}
